const ApiConstant: any = {
    getOperationSummary: "/Sites/GetOperationSummaryDetails",
    getRoutesSummary: "/Route",
    getOperationDetailsDates: "/OperationDetails/GetLeakDateList/",
    getToken: "/api/token",
    getAllCustomerList: "/api/customer/getallcustomers",
    getUser: "/api/auth/getuser",
    addOrUpdateAogiSite: "/api/assets/uploadaogisites",
    getSurveyDetails: "/api/assets/GetAOGISurveyDetails",
    addOrUpdateSurveyDetails: "/api/assets/UpdateSurveyEmission",
    addOrUpdateSurveyDetailsNew: "/api/assets/UpdateSurveyEmissionNew",
    dowloadFiles: "/api/assets/DownloadBlobByID",
    removeSiteDetails: "/api/assets/RemoveAOGISurveySites",
    removeEmissionDetails: "/api/assets/RemoveSurveyEmission",
    getAogiSites: "/api/assets/getaogisites",
    removeAogiSite: "/api/assets/removeaogisite",
    addSurvey: "/api/assets/createaogisurvey",
    getAOGISurveys: "/api/assets/getaogisurveys",
    updateAogiSurvey: "/api/assets/updateaogisurvey",
    removeAogiSurvey: "/api/assets/removeaogisurvey",
    GetAOGIAllSurveyDetails: "/api/assets/GetAOGIAllSurveyDetails",
    getPermissionsOfCurrentUser: "api/auth/getUserPermissions",
    GetBlobURI: "/api/assets/GetBlobURI",
    SiteSummary: "/api/sites/",
    postUpdateSiteSummary: "/api/Sites/UpdateSite/",
    addSiteSummary: "/api/Sites/CreateSite/",
    getAllCustomers: "/api/Customers/",
    getSurveyOverview: "/api/OperationDetails/GetSurveyOverview",
    getOperationDetails: "/api/OperationDetails/OperationLeakDetails/",
    getRouteBySite:"/api/Route/GetRouteDetailsForSite/",
    getCameraOperators:"/api/CameraOperator",
    getbyCameraOperatorId:"/api/CameraOperator/GetbyOperatorId/",
    UpdateCameraOperator:"/api/CameraOperator/UpdateOperator/",
    deleteCameraOperator:"/api/CameraOperator/DeleteOperator/"
};

export default ApiConstant;
